export class DigitalShipmentFiltersCounts {
    All: number;
    Active: number;
    Closed: number;
    AtOrigin: number;
    AtOriginAir: number;
    AtOriginOcean: number;
    AtOriginInland: number;
    InTransit: number;
    InTransitAir: number;
    InTransitOcean: number;
    InTransitInland: number;
    AtDestination: number;
    AtDestinationAir: number;
    AtDestinationOcean: number;
    AtDestinationInland: number;
}